import { Component, computed, inject, signal } from '@angular/core';
import { BaseModalComponent } from "../../../../../../core/components/modals/base-modal/base-modal.component";
import {
  CopyRrcLimitParams,
  RrcLimitCopyDialogData
} from "./types/rrc-limits-copy-config.types";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatButton } from "@angular/material/button";
import {
  CustomMatSelectComponent
} from "../../../../../../shared/components/ui/custom-mat-select/custom-mat-select.component";
import { RrcLimitsCopyService } from "./services/rrc-limits-copy.service";
import { rrcLimitsCopyModalName } from "./configs/rrc-limits-copy-config";
import { LoaderComponent } from "../../../../../../shared/components/loader/loader.component";

@Component({
  selector: 'app-rrc-limits-copy-modal',
  imports: [
    BaseModalComponent,
    MatButton,
    CustomMatSelectComponent,
    LoaderComponent
  ],
  templateUrl: './rrc-limits-copy-modal.component.html',
  styleUrl: './rrc-limits-copy-modal.component.scss'
})
export class RrcLimitsCopyModalComponent extends BaseModalComponent {
  private rrcLimitCopyDialogData = inject<RrcLimitCopyDialogData>(MAT_DIALOG_DATA);
  private rrcLimitsCopyService: RrcLimitsCopyService = inject(RrcLimitsCopyService);

  public selectedArticleId = signal<string>('');
  public articleSelectData = computed(() => this.rrcLimitCopyDialogData.articleSelectData);
  public titleModal = computed(() => `Создать копию №${this.rrcLimitCopyDialogData.copyId}`);

  public override ngOnInit(): void {
    super.ngOnInit();
    this.modalStatesService.openModal(rrcLimitsCopyModalName);
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(rrcLimitsCopyModalName);
  }

  public handleSelectChange(value: string): void {
    this.selectedArticleId.set(value);
  }

  public async confirmCopy(): Promise<void> {
    this.loadingService.setIsLoadingState(true);
    const params: CopyRrcLimitParams = {
      copyId: this.rrcLimitCopyDialogData.copyId,
      newArticle: this.selectedArticleId()
    };

    await this.rrcLimitsCopyService.copyRrcLimit(params)
      .then(() => this.closeDialog('success'))
      .finally(() => this.loadingService.setIsLoadingState(false));
  }
}
